import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./HeaderWithClient.js";
import AlertDialog from "../../components/AlertDialog.js";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { UPDATE_CLIENT_TERMS_CONFIGURE_MUTAION , GET_CLIENT_UUID } from "../../graphQL/client_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#0D47A1",
      color: "white",
      fontSize: 18,
      fontWeight: 700,
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    // "& .style--true": {
    //   backgroundColor: "#FFFFFF",
    // },
    // "& .style--false": {
    //   backgroundColor: "#E2EDF5", //#E3F2FD",
    // },
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: "#E2EDF5",
    },
    [`& .${gridClasses.row}.even:hover`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd:hover`]: {
      backgroundColor: "#E2EDF5",
    },
    [`& .${gridClasses.row}.even.Mui-selected`]: {
      backgroundColor: "#FFFFFF !important",
    },
    [`& .${gridClasses.row}.odd.Mui-selected`]: {
      backgroundColor: "#E2EDF5 !important",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  datePickerStyle: {
    width: "100%",
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

function ConfigureTermSettings() {

  //const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  
  const [clientData, setClientData] = useState();
  const [startDate, handleStartDateChange] = useState("");
  const [termStartDate, setTermStartDate] = useState();
  const [termNoOfWeeks, setTermNoOfWeeks] = useState(0);

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  let loadData = true;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");
  if (clientId == 0)
    loadData = false;

  const [editAccess, setEditAccess] = useState(true);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    console.log('clientId',clientId)
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Configure Terms"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      console.log('commonActions',commonActions)
      if(commonActions.find(a => a == "Edit")){
        setEditAccess(true);}
      else {setEditAccess(false);}


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  

  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState({
    termNoOfWeeks: "", 
    termStartDate: "",   
  });

  const [fetchClientData] = useManualQuery(GET_CLIENT_UUID, {
    fetchPolicy: "network-only",
  });

   const [updateClientTermsConfigure] = useMutation(UPDATE_CLIENT_TERMS_CONFIGURE_MUTAION, {
    awaitRefetchQueries: true,
  })

  const [alertMsg, setAlertMsg] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  const getClientData = async () => {
    const {
      loading: clientLoading,
      error: clientError,
      data: clientData,
    } = await fetchClientData({
      variables: {
        clientId: parseInt(clientId),
      },
    });

    if (!clientLoading && clientData && clientData.getClientData) {
      setClientData(clientData.getClientData);
      setTermStartDate(clientData.getClientData.termStartDate);        
      setTermNoOfWeeks(clientData.getClientData.termNoOfWeeks); 
      loadData = true;
    }
    else 
      loadData = false;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getClientData())();
  }, []);

  const updateTermsWeek = (value) => {
    let message = ""
    if (parseInt(value) < 1) {
      message = "Enter an integer greater than zero." ;
    } else if (parseInt(value) > 99) {
      message = "Enter an integer less than 100.";
    } else if (value.toString().trim() === "") {
      message = "No of Weeks cannot be blank.";
    }
    if (message == ""){
        setTermNoOfWeeks(value);
        setErrorMsg({ ...errorMsg, termNoOfWeeks: "" });      
    }
    else
        setErrorMsg({ ...errorMsg, termNoOfWeeks: message });      
  };

  const updateTermsStartDate = (value) => {
    let message = ""
    console.log(value);
    let startDate = new Date(value).toLocaleDateString('sv-SE')
    if (!value || startDate == "" || startDate == "Invalid Date")
      message = "Start Date cannot be blank"
    if (message == ""){
      setTermStartDate(startDate);
      setErrorMsg({ ...errorMsg, termStartDate: "" });   
    }
    else
        setErrorMsg({ ...errorMsg, termStartDate: message });   
  };

  const onSubmit = async formData => {
      if(errorMsg.termStartDate){
        setErrorMsg({ ...errorMsg, termStartDate: "Start Date cannot be blank." });
        return;
      }
      else{
        const { data, error } = await updateClientTermsConfigure({
          variables: {
            clientId: parseInt(clientId),
            noOfWeeks: parseInt(formData.termNoOfWeeks),
            startDate: termStartDate,
          },
        });
        if (error) {
          console.log("Error", error, data);
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        } else if (data && data.updateClientTermsConfigure) {
          console.log("Success", data);
          setAlertMsg({
            title: "Success",
            msg: "Client Term Configuration has been successfully updated.",
          });
        }
      }
  };


  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 15,
            paddingBottom: 15,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Configure Term
            </Typography>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
  if (loadContent)
    if (loadData)
    if (editAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: 'General Settings', link: null },
                              { label: 'Configure Terms', link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Configure Term
            </Typography>
          </Box>
          <Divider />

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>
               <TextField
                  className={classes.textFieldStyle}
                  autoFocus
                  fullWidth
                  label="No of Weeks"
                  margin="normal"
                  variant="outlined"
                  name="termNoOfWeeks"
                  id="termNoOfWeeks"
                  variant="outlined"
                  value={termNoOfWeeks}
                  type="number"
                  onKeyDown={e => {
                    if (e.keyCode >= 65 && e.keyCode <= 90) {
                      e.preventDefault();
                    }
                  }}
                  InputProps={{
                    inputProps: { min: 1, max: 99, pattern: "^[1-9][0-9]?$" },
                  }}
                  {...register("termNoOfWeeks", { required: true })}
                  onChange={e =>updateTermsWeek(e.target.value)}
                />
                {errorMsg.termNoOfWeeks && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.termNoOfWeeks}
                  </FormHelperText>
                )}
              </Grid>              
            </Grid>

            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>
                <Box pb={2} style={{ fontSize: 14,fontFamily: "Arial"}}>
                  Enter the start date of the first period in the Sprint within the Term.
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs} >
                  <DatePicker
                    className={classes.datePickerStyle}
                    autoFocus
                    fullWidth
                    label="Start Date"
                    value={dayjs(termStartDate)}
                    name="termStartDate"
                    id="termStartDate"
                    onChange={date => (updateTermsStartDate(date))}
                  />
                </LocalizationProvider>
                {errorMsg.termStartDate && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.termStartDate}
                  </FormHelperText>
                )}
                {errors.termStartDate && errors.termStartDate.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Term start date cannot be blank.
                      </FormHelperText>
                    </Box>
                )}
              </Grid>              
            </Grid>
            <Box pt={4} pb={2}>
              <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonStyle}
                  style={{ marginRight: 2 }}
                  type="submit"
              >
                Save
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/tenant/dashboard`)}
              >
                Cancel
              </Button>
            </Box>
          </form>

        {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/tenant/settings/term`);
              }}
            />
          )}

        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Client"
                contentMsg='There is no client in this Tenant. Please create a client.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default ConfigureTermSettings;
